import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'
import Provider from '@theme/Provider'

import MainLayout from '@layout/MainLayout'

import { persist } from '@store/store'

import '@theme/fonts.css'

const App = () => {
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    persist().then(() => setLoading(false))
  }, [])

  if (loading) {
    return null
  }

  return (
    <Provider>
      <MainContainer>
        <MainLayout />
      </MainContainer>
    </Provider>
  )
}

export default App

const MainContainer = styled(View)`
  flex: 1;
  background-color: ${(props) => props.theme.colors.background};
`
